/**
 * 可视化埋点postMessage 201218
 * @method sendEyeLego(params)
 * @param {object} params 埋点参数
 * @param {string} params.pagetype 页面类型
 * @param {string} params.actiontype 事件类型
 * @param {string} params.backup 参数
 * @param {boolean} params.isShow 【可选】是否为展现埋点(也可从backup中获取)
 * @param {string} params.eventType  【可选】行为事件：包括‘show’、‘click’、 ‘unload’; isShow 是否为展现埋点(也可从backup中获取)
 * by zhangying
 */

// 埋点平台域名
var __parentHttp = ['https://legopf.zhuanspirit.com', 'https://zznba.zhuanspirit.com'];
// 插入开发者小工具，可扩展  __setToolEvenFlag 插入标志位,确保不重复插入
var __setToolEvenFlag = false;
var __setDevToolEvent = function __setDevToolEvent() {
  try {
    __setToolEvenFlag = true;
    var tt = new Date().getTime();
    var src = "https://s1.zhuanstatic.com/common/biz/js/dev-tool-func.js?".concat(tt);
    var script_dom = document.createElement('script');
    script_dom.src = src;
    script_dom.language = 'javascript';
    script_dom.type = 'text/javascript';
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(script_dom);
  } catch (e) {
    console.log('__setDevToolEvent error', e);
  }
};
export var isSendEyeLego = function isSendEyeLego() {
  try {
    if (typeof window === 'undefined') return false;
    var __location = document.location || {};
    var pIndex = __parentHttp.indexOf(__location.ancestorOrigins[0]);
    if (pIndex === -1) {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
};
export var sendEyeLego = function sendEyeLego(params) {
  try {
    var __location = document.location || {};
    var pIndex = __parentHttp.indexOf(__location.ancestorOrigins[0]);
    if (pIndex === -1) {
      return;
    }
    var InIframe = window.self !== window.top;
    if (!InIframe) return;
    if (!__setToolEvenFlag) {
      __setDevToolEvent();
    }
    var _ref = params || {},
      backup = _ref.backup;
    var __backup = backup && decodeURIComponent(backup) || '';
    __backup = __backup && JSON.parse(__backup) || {};
    var _ref2 = params || {},
      isShow = _ref2.isShow,
      eventType = _ref2.eventType;
    isShow = isShow || __backup.isShow || false;
    eventType = eventType || __backup.eventType || false;
    // eventType 行为事件：包括‘show’、‘click’、 ‘unload’; isShow 是否为展现埋点
    var __eventType = eventType;
    if (!__eventType) {
      var __eventTypeClick = 'click';
      var __eventTypeShow = 'show';
      __eventType = isShow ? __eventTypeShow : __eventTypeClick;
    }
    // 如果在iframe中向埋点平台发送msg
    var _ref3 = params || {},
      _ref3$pagetype = _ref3.pagetype,
      pagetype = _ref3$pagetype === void 0 ? 'ZHUANZHUANM' : _ref3$pagetype,
      actiontype = _ref3.actiontype;
    window.parent.postMessage({
      type: 'eye-lego',
      eventType: __eventType,
      pageType: pagetype,
      actionType: actiontype,
      backup: __backup
    }, __parentHttp[pIndex]);
  } catch (error) {
    console.log('可视化埋点方案 error: ', error);
  }
};